import LayoutAuth from './LayoutAuth'

export default LayoutAuth
